module.exports = __webpack_public_path__ + "media/abk/assets/images/carrer_office_logo-7d6da4581e65ea9e4854cb56965888f8.png";